import { render } from "./failed.vue?vue&type=template&id=5d56805b&ts=true"
import script from "./failed.vue?vue&type=script&lang=ts"
export * from "./failed.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__